<template>
  <FontAwesomeIcon
    :icon="iconDefinition.iconName"
    :size="size"
    :data-test="`fontIcon-${iconDefinition.iconName}`"
  />
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library, config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

/** @typedef {import('@fortawesome/fontawesome-common-types').IconDefinition} IconDefinition */

export default defineComponent({
  components: {
    FontAwesomeIcon,
  },
  props: {
    /**
     * @type {import('vue').PropOptions<IconDefinition>}
     */
    iconDefinition: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    library.add(props.iconDefinition);
  },
});
</script>
